<template>
  <div class="about">
    <version-chat-r-d-g />
  </div>
</template>

<script>
// @ is an alias to /src
import VersionChatRDG from "@/components/VersionChatRDG.vue";

export default {
  name: "VersionChatbotView",
  components: {
    VersionChatRDG,
  },
};
</script>
